import { render, staticRenderFns } from "./PosInvoiceTemplate1.vue?vue&type=template&id=5e4bb62c&"
import script from "./PosInvoiceTemplate1.vue?vue&type=script&lang=js&"
export * from "./PosInvoiceTemplate1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports